import {
  AdminSpinner,
  ListSpinner,
  QueryStatus,
  noVDrive,
} from '@vgrubs/components';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';
import { useVerificationsVDriveInfiniteScroll } from '../hooks/useVerificationsVDriveInfiniteScroll';
import { VDriveComponent } from '../components/VDriveComponent';

export const VDriveVerifications = ({ query }: { query: string }) => {
  const { vDriveVerifications, observerRef, isFetchingNextPage, status } =
    useVerificationsVDriveInfiniteScroll(query);

  return (
    <>
      {vDriveVerifications.map((vDriveVerification) => (
        <VDriveComponent
          key={vDriveVerification.id}
          vDriveVerification={vDriveVerification}
        />
      ))}

      {vDriveVerifications.length === 0 &&
        status !== QueryStatus.PENDING &&
        !isFetchingNextPage && (
          <NoDataComponent
            image={noVDrive}
            title="No vDrive!"
            description={
              query
                ? `No vDrive to verify match "${query}".`
                : 'You currently do not have any vDrive to verify.'
            }
            height="70vh"
            heightSM="70vh"
          />
        )}

      <ListSpinner loading={isFetchingNextPage} observerRef={observerRef} />
      {status === QueryStatus.PENDING && <AdminSpinner />}
    </>
  );
};
